import React, { useRef, useState } from 'react';
import { IonButton } from '@ionic/react';
import { useCartSuggestions } from '../../../hooks/useCartSuggestions';
import { buildCartItem, cartMoney } from '../../../Utils/cartItem';
import { CartSuggestion } from '../../../Utils/cartApi';
import './CartSuggestions.css';

type Props = { empresa: any; produtos: any[]; agendamento: any;
  adicionarItem?: Function; onChooseProduct?: (productId: string) => Promise<void> };

export default function CartSuggestions(props: Props) {
  const suggestions = useCartSuggestions(props.empresa?.pk || localStorage.getItem('empresaid') || '',
    props.produtos, props.agendamento);
  const [busy, setBusy] = useState<string | null>(null);
  const pending = useRef(false);
  const [error, setError] = useState('');
  if (!suggestions.length || !props.adicionarItem || !props.onChooseProduct) return null;
  const select = async (suggestion: CartSuggestion) => {
    if (pending.current) return;
    pending.current = true;
    setBusy(suggestion.productId);
    setError('');
    try {
      if (suggestion.requiresConfiguration) {
        await props.onChooseProduct!(suggestion.productId);
      } else {
        const product = props.empresa?.catalogoProdutos?.find((item: any) => item.id === suggestion.productId)
          || { id: suggestion.productId, nome: suggestion.name, valor: cartMoney(suggestion.price) };
        const category = props.empresa?.categoriaProdutos?.find((item: any) => item.nome === product.categoria);
        await props.adicionarItem!(buildCartItem({ product, category, unitPrice: suggestion.price }));
      }
    } catch (e: any) {
      setError(e.message || 'Não foi possível adicionar o produto. Tente novamente.');
    } finally {
      pending.current = false;
      setBusy(null);
    }
  };
  return <section className="cart-suggestions" aria-labelledby="cart-suggestions-title">
    <h2 id="cart-suggestions-title">Complete seu pedido</h2>
    <div className="cart-suggestions-list" aria-label="Produtos complementares">
      {suggestions.map(suggestion => <article className="cart-suggestion" key={suggestion.productId}>
        <div className="cart-suggestion-info">
          {suggestion.image && <img src={suggestion.image} alt="" loading="lazy" />}
          <div><h3>{suggestion.name}</h3><p>{suggestion.priceFrom ? 'A partir de ' : ''}R$ {cartMoney(suggestion.price)}</p></div>
        </div>
        <IonButton expand="block" fill="outline" disabled={busy !== null} onClick={() => { void select(suggestion); }}
          aria-label={`${suggestion.requiresConfiguration ? 'Escolher' : 'Adicionar'} ${suggestion.name}`}>
          {busy === suggestion.productId ? 'Aguarde…' : suggestion.requiresConfiguration ? 'Escolher' : 'Adicionar'}
        </IonButton>
      </article>)}
    </div>
    {error && <p role="alert" className="cart-suggestions-error">{error}</p>}
  </section>;
}
